import * as type from '../../constants';

const initialState = {
    consultantRatings: [],
    loading: false,
    error: null,

    downloadLoader: false,
}

export function consultantRatings(state = initialState, action) {
    switch (action.type) {
        case type.GET_CONSULTANT_RATINGS_DATA:
            return {
                ...state,
                loading: true,
            }
        case type.GET_CONSULTANT_RATINGS_DATA_SUCCESS:
            return {
                ...state,
                consultantRatings: action.consultantRatingsRes,
                loading: false,
                error: null
            }
        case type.GET_CONSULTANT_RATINGS_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.message,
            }


        case type.DOWNLOAD_CONSULTANT_RATING_EXCEL:
            return {
                ...state,
                downloadLoader: true,
            }
        case type.DOWNLOAD_CONSULTANT_RATING_EXCEL_SUCCESS:
            return {
                ...state,
                downloadLoader: false,
            }
        case type.DOWNLOAD_CONSULTANT_RATING_EXCEL_FALIURE:
            return {
                ...state,
                downloadLoader: false,
            }
        default:
            return state
    }
}